// Service for calling Claude API to extract recipes from images
// Now uses proxy server to avoid CORS issues

/**
 * Converts image file to base64 string
 */
async function imageToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      // Remove data URL prefix to get just the base64 string
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

/**
 * Extracts recipes from an image using Claude API via proxy server
 * @param {File} imageFile - The image file to analyze
 * @returns {Promise<Array>} - Array of extracted recipes
 */
export async function extractRecipesFromImage(imageFile) {
  try {
    // Use production server URL or localhost for development
    const API_URL = import.meta.env.PROD 
      ? "https://allthese-server.onrender.com"
      : "http://localhost:3001";

    // Convert image to base64
    const base64Image = await imageToBase64(imageFile);
    
    // Determine media type
    const mediaType = imageFile.type || 'image/jpeg';
    
    // Call proxy server
    const response = await fetch(`${API_URL}/api/extract-recipes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        imageData: base64Image,
        mediaType: mediaType
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to extract recipes');
    }

    const result = await response.json();
    
    return result.recipes || [];
    
  } catch (error) {
    console.error('Error extracting recipes:', error);
    throw error;
  }
}

/**
 * Test function to verify proxy server is working
 */
export async function testProxyServer() {
  try {
    const API_URL = import.meta.env.PROD 
      ? "https://allthese-server.onrender.com"
      : "http://localhost:3001";

    const response = await fetch(`${API_URL}/api/health`);
    
    if (!response.ok) {
      throw new Error('Proxy server not responding');
    }

    const data = await response.json();
    console.log('Proxy server test successful:', data);
    return true;
  } catch (error) {
    console.error('Proxy server test failed:', error);
    console.error('Make sure server is running');
    return false;
  }
}